/**
 *
 * AuthPageContainer
 *
 */
import React from 'react';
import Logo from 'images/logo.svg';
import {
  Box,
  Container,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';

interface Props {
  children: React.ReactChild;
}

export function AuthPageContainer(props: Props) {
  const theme = useTheme();
  const hideLgDown = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '100vh',
      }}
    >
      <Container maxWidth="sm">
        {!hideLgDown && (
          <Stack direction={'column'} alignItems={'center'} mb={4}>
            <img style={{ maxWidth: 200 }} src={Logo} alt="Barbourne Brook" />
          </Stack>
        )}
        <Paper
          sx={{ p: [4], my: 4 }}
          square
          elevation={5}
          style={{ backgroundColor: theme.palette.grey[50] }}
        >
          {React.Children.only(props.children)}
        </Paper>

        {!hideLgDown && (
          <Box mb={2} textAlign={'center'}>
            <Typography variant={'subtitle2'} color="textSecondary">
              CAT360 {new Date().getFullYear()} - Barbourne Brook Customs
              Planning - All Rights Reserved
            </Typography>
          </Box>
        )}
      </Container>
    </Box>
  );
}
